exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".recaptcha-container[data-v-ad9a1596]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;min-height:78px;width:100%;margin-top:16px}.v-messages.error--text[data-v-ad9a1596]{margin-top:4px;text-align:center;width:100%;padding-left:12px;padding-right:12px}[data-v-ad9a1596] .v-input--checkbox .v-label a{pointer-events:auto;text-decoration:underline}[data-v-ad9a1596] .v-input--checkbox .v-label a:hover{color:var(--v-anchor-base)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-ad9a1596","scoped":true,"sourceMap":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/common/dialog/types/DialogContactForm.vue
// module id = 1050
// module chunks = 22